module.exports = __webpack_public_path__ + "3B6Hgy_M.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/GrueneKarte.svg
// module id = ./src/img/GrueneKarte.svg
// module chunks = main